// data/starterSubreddits.js

export const starterSubreddits = [
  "ADHD",
  "productivity",
  "Notion",
  "bujo",
  "Journaling",
  "ObsidianMD",
  "freelance",
  "students",
  "Teachers",
  "Excel",
  "GetStudying",
  "DigitalNomad",
  "personalfinance",
  "povertyfinance",
  "sidehustle",
  "EtsySellers",
  "Entrepreneur",
  "WorkOnline",
  "selfimprovement",
  "simpleliving",
  "GetDisciplined",
  "Parenting",
  "anxiety",
  "Frugal",
];
